const rooster = {
  conversationItem: {
    cursor: 'pointer',
    textAlign: 'left',
    paddingLeft: '15px',
    color: 'black',
    height: '40px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  selectedConversationItem: {
    backgroundColor: '#673ab7',
    cursor: 'pointer',
    textAlign: 'left',
    paddingLeft: '15px',
    color: 'white',
    height: '40px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  names: {
    width: 'calc(100% - 100px)',
    fontSize: '0.9em',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'noWrap',
  },
  datetime: {
    fontSize: '0.75em',
    textAlign: 'right',
    flex: '0 0 55px',
  },
  icon: {
    width: '24px',
    height: '24px',
    flex: '0 0 45px',
  },
  iconColorForActiveConvo: '#673ab7',
  conversationItemsList: {
    // no op, tops has a special rule though
  },
}

const tops = {
  conversationItem: {
    cursor: 'pointer',
    textAlign: 'left',
    paddingLeft: '15px',
    color: 'black',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  selectedConversationItem: {
    background: 'linear-gradient(#63aef8, #1672fb)',
    cursor: 'pointer',
    textAlign: 'left',
    paddingLeft: '15px',
    color: 'white',
    height: '40px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  names: {
    width: 'calc(100% - 100px)',
    fontSize: '0.9em',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'noWrap',
    marginRight: 'auto',
  },
  datetime: {
    fontSize: '0.75em',
    textAlign: 'right',
    flex: '0 0 55px',
  },
  icon: {
    width: '24px',
    height: '24px',
    flex: '0 0 45px',
  },
  iconColorForActiveConvo: '#e72da1',
  conversationItemsList: {
    padding: 0,
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Messages/styles/ConversationsListItem.js